@let showClose = data.showClose ?? true;
<onyx-modal
  variant="center"
  [size]="480"
  [heading]="data.heading"
  [showClose]="showClose && !loading()"
  [closeDisabled]="loading()"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
  (keydown.escape)="showClose && !loading() ? close$.next(undefined) : null"
>
  <div class="container">
    @if (data.badges; as badges) {
      <div class="badges">
        @for (badge of badges; track badge.value) {
          <onyx-badge [color]="badge.color">
            {{ badge.value | translate }}
          </onyx-badge>
        }
      </div>
    }

    {{ data.message || '' | translate }}

    @if (data.templateRef) {
      <ng-container *ngTemplateOutlet="data.templateRef"></ng-container>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button
      variant="outlined"
      [disabled]="loading()"
      (click)="!loading() ? close$.next(false) : null"
    >
      {{ data.cancelButtonText ?? `${I18N}.common.cancel` | translate }}
    </onyx-button>

    <onyx-button
      [color]="data.confirmButtonColor ?? 'black'"
      [spinner]="loading()"
      (click)="confirm()"
    >
      {{ data.confirmButtonText | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
